/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_LegsInputs */

const en_us2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legs`)
};

const pt_br2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pernas`)
};

const es_419_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piernas`)
};

const pt_pt2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pernas`)
};

const fr_fr2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jambes`)
};

const de_de2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beine`)
};

const it_it2_catalog_movement_legs = /** @type {(inputs: Catalog_Movement_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambe`)
};

/**
* | output |
* | --- |
* | "Legs" |
*
* @param {Catalog_Movement_LegsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_legs = /** @type {((inputs?: Catalog_Movement_LegsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_LegsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_legs(inputs)
	if (locale === "es-419") return es_419_catalog_movement_legs(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_legs(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_legs(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_legs(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_legs(inputs)
	return en_us2_catalog_movement_legs(inputs)
});
export { catalog_movement_legs as "catalog.movement.legs" }